import { EbookNew } from './EbookNew'
import { withEbookNew } from './withEbookNew'

const Connected = withEbookNew(EbookNew)

export { Connected as EbookNew }
